import { render, staticRenderFns } from "./catal.vue?vue&type=template&id=5e2a25e2&scoped=true&"
import script from "./catal.vue?vue&type=script&lang=js&"
export * from "./catal.vue?vue&type=script&lang=js&"
import style0 from "./catal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./catal.vue?vue&type=style&index=1&id=5e2a25e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2a25e2",
  null
  
)

export default component.exports